export const IN_DETAILED_HISTORY= 'in-detailed-history';
export const IN_GAME = "in-game";